import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Componentes
import { ParticipanteListaComponent } from './participante/participante-lista/participante-lista.component';
import { ParticipantesFormComponent } from './participante/participante-form/participante-form.component';
import { FuncionarioFormComponent } from './funcionario/funcionario-form/funcionario-form.component';
import { FuncionariosListaComponent } from './funcionario/funcionarios-lista/funcionarios-lista.component';
import { AuthGuard } from '@app/guards/auth.guard';

const cadastrosRoutes: Routes = [
  { path: 'participante/novo', component: ParticipantesFormComponent, canActivate: [AuthGuard] },
  { path: 'participante/editar/:id', component: ParticipantesFormComponent, canActivate: [AuthGuard] },
  { path: 'participante/lista/:busca', component: ParticipanteListaComponent, canActivate: [AuthGuard] },
  { path: 'participante', component: ParticipanteListaComponent, canActivate: [AuthGuard] },

  { path: 'funcionario', component: FuncionariosListaComponent, canActivate: [AuthGuard] },
  { path: 'funcionario/novo', component: FuncionarioFormComponent, canActivate: [AuthGuard] },
  { path: 'funcionario/editar/:id', component: FuncionarioFormComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(cadastrosRoutes)],
  exports: [RouterModule]
})
export class CadastrosRoutingModule { }
